import React, { useState } from 'react';
import styles from './addCandidate.module.scss';
import { Container, Row, Col, Modal, Button, Form } from 'react-bootstrap';
import * as yup from 'yup';
import { Formik } from 'formik';
import { CustomTextField } from '../../../../shared/customTextField';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CustomDropZone from '../../../../shared/customDropZone';
import { CustomButton } from '../../../../shared/customButton';
import { getCVPresignedURL, uploadCV, uploadImage, uploadCoverLetter } from '../../../../../services/util/candidates';
import { addCandidate } from '../../../../../services/util/hiringpipeline/candidates';
import { useParams } from 'react-router-dom';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
var moment = require('moment-timezone');

function AddCandidate(props) {
    let [uploadType, setUploadType] = useState(30);
    let { id } = useParams();
    let [isUploadLoading, setUploadLoading] = useState(false);
    let [timeZone, setTimeZone] = useState(String(moment.tz.guess()));

    //yup validations
    const schema = yup.object({
        candidateEmail: yup.string().trim().email('Should be a valid email address').required('Required'),
        candidateFName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        candidateLName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        candidateNumber: yup.string().trim().min(8, 'Should be more than 4 digits').required('Required'),
        candidateCV: yup.array().required('Required'),
        candidateCoverLetter: yup.array(),
        salaryExpectation: yup.number().typeError("Only numbers allowed").when('requestSalaryExpection', { is: (value) => value === true, then: ()=> yup.number().positive().typeError("Only numbers allowed").required('Required').min(0), otherwise: ()=> yup.number().positive().typeError("Only numbers allowed").min(0) }),
        employeeDetails: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('check referels', 'Required', function (value) {
            if (uploadType === 10) {
                if (!value) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        }),
        recruiterDetails: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('check referels', 'Required', function (value) {
            if (uploadType === 20) {
                if (!value) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        }),
        availableDateTime: yup.string().test('date check', 'Past Dates Not Accepted', function (item) {
            let setDate = moment(item).format("YYYY-MM-DD HH:mm");
            let setDateObj = moment.tz(setDate, timeZone);
            let currentDate = moment().tz(timeZone);

            if (setDateObj.diff(currentDate, 'days') >= 0) {
                return true;
            } else {
                return false;
            }
        }).when('requestAvailableDate', { is: (value) => value === true, then: () => yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'), otherwise: ()=> yup.string() }),
    });
    //on submit function
    const onSubmit = async (values) => {
        let imageType = null;
        let isCoverLetterUpload = false;
        //start loading
        setUploadLoading(true);
        //seperate image type
        imageType = values.candidateImage && ((values.candidateImage[0].type).split('/')[1]).toLowerCase();
        //seperate from first space and take country code
        let mobileCountryCode = (values.candidateNumber).substr(0, (values.candidateNumber).indexOf(' '));
        //take mobile number except country code
        let mobileNum = (values.candidateNumber).substr((values.candidateNumber).indexOf(' ') + 1);

        let presignedURL = await getCVPresignedURL({ isInvitedCandidate: false, isManuallyUploaded: true, pipelineID: id, email: values.candidateEmail, candidateImageType: imageType });
        if (presignedURL.success === true) {
            let respondCandidateID = presignedURL.data.candidate_id;
            let respond = await uploadCV(presignedURL.data.presigned_url.cv_upload, values.candidateCV[0]);
            if (respond.status === 200) {
                //upload image if image selected
                if ((values.candidateImage) && (values.candidateImage).length > 0) {
                    let respondImage = await uploadImage(presignedURL.data.presigned_url.image_upload, values.candidateImage[0]);
                    if (respondImage.status !== 200) {
                        setUploadLoading(false);
                    }
                }

                if ((values.candidateCoverLetter && ((values.candidateCoverLetter).length > 0))) {
                    let respondCoverLetter = await uploadCoverLetter(presignedURL.data.presigned_url.cover_letter_upload, values.candidateCoverLetter[0]);
                    if (respondCoverLetter !== 200) {
                        isCoverLetterUpload = true;
                        setUploadLoading(false);
                    }
                }


                let data = {
                    candidate_id: respondCandidateID,
                    candidate_image_type: imageType,
                    is_invited_candidate: false,
                    is_cover_letter_uploaded: isCoverLetterUpload ? true : false,
                    candidate_first_name: values.candidateFName,
                    candidate_last_name: values.candidateLName,
                    mobile_country_code: mobileCountryCode,
                    mobile_number: mobileNum,
                    referral_data: values.uploadType === 10 ? values.employeeDetails : values.uploadType === 20 ? values.recruiterDetails : null,
                    manually_uploaded_status: values.uploadType,
                    expected_salary_amount: values.salaryExpectation ? values.salaryExpectation : null,
                    expected_salary_currency: props.pipelineData.job_details.paid_currency,
                    expected_salary_paid_by: props.pipelineData.job_details.salary_paid_by,
                    available_date: values.availableDateTime

                }

                let addCandidateRespond = await addCandidate(data);
                if (addCandidateRespond.success === true) {
                    setUploadLoading(false);
                    props.handleClose();
                    props.getPipelineValues();
                } else {
                    setUploadLoading(false);
                }

            } else {
                setUploadLoading(false);
            }
        } else {
            setUploadLoading(false);
        }
    }

    const changeUploadType = (value) => {
        setUploadType(value)
    }

    //check validity of dates
    let yesterday = moment().tz(timeZone).subtract(1, 'day');
    let valid = function (current) {
        return current.isAfter(yesterday);
    };


    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Add Candidate</h2>
                    </div>
                    <Col sm={12} className="mb-4">
                        <Container>
                            <p className={styles.stepSubtopicName}>Candidate Details</p>
                        </Container>
                    </Col>
                    <Col sm={12}>
                        <Container>
                            <Formik
                                validationSchema={schema}
                                onSubmit={(values) => onSubmit(values)}
                                initialValues={{
                                    uploadType: uploadType, availableDateTime: moment(), requestAvailableDate: props.pipelineData.apply_form_settings.request_available_date, requestSalaryExpection: props.pipelineData.apply_form_settings.request_salary_expectation,
                                }}>

                                {({
                                    values,
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                    setFieldValue,
                                    submitCount
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <CustomTextField
                                            label="Email"
                                            classLabel="defaultLabel"
                                            controlId="adminPanel_hiringPipeline_viewPipeline_addCandidate_emailFieldId"
                                            type="email"
                                            name="candidateEmail"
                                            classType="defaultTextBox"
                                            handleOnChange={handleChange}
                                            errorMessage={errors.candidateEmail}
                                            validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_emailvalidationMsgId"
                                            isInvalid={submitCount > 0 && !!errors.candidateEmail}
                                        />
                                        <Row>
                                            <Col>
                                                <CustomTextField
                                                    label="First Name"
                                                    classLabel="defaultLabel"
                                                    controlId="adminPanel_hiringPipeline_viewPipeline_addCandidate_fistNameFieldId"
                                                    type="text"
                                                    name="candidateFName"
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    errorMessage={errors.candidateFName}
                                                    validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_firstNamevalidationMsgId"
                                                    isInvalid={submitCount > 0 && !!errors.candidateFName}
                                                />
                                            </Col>
                                            <Col>
                                                <CustomTextField
                                                    label="Last Name"
                                                    classLabel="defaultLabel"
                                                    controlId="adminPanel_hiringPipeline_viewPipeline_addCandidate_lastNameFieldId"
                                                    type="text"
                                                    name="candidateLName"
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    errorMessage={errors.candidateLName}
                                                    validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_lastNamevalidationMsgId"
                                                    isInvalid={submitCount > 0 && !!errors.candidateLName}
                                                />
                                            </Col>
                                        </Row>
                                        <Form.Group>
                                            <Form.Label
                                                className={styles.defaultLabel}>
                                                Phone Number
                                            </Form.Label>
                                            <PhoneInput
                                                country='us'
                                                value={values.candidateNumber}
                                                inputProps={{ id: 'adminPanel_hiringPipeline_viewPipeline_addCandidate_mobileFieldId' }}
                                                onChange={(value, country, e, formattedValue) => { setFieldValue('candidateNumber', formattedValue) }}
                                                isValid={(submitCount > 0 && errors.candidateNumber) ? false : true}
                                                inputClass={(submitCount > 0 && errors.candidateNumber) ? `${styles.inputboxNumberError}` : `${styles.inputboxNumber}`}
                                            />
                                            {submitCount > 0 &&
                                                <p className={styles.errorLabel} id="adminPanel_hiringPipeline_viewPipeline_addCandidate_mobilevalidationMsgId" >{errors.candidateNumber}</p>
                                            }
                                        </Form.Group>
                                        <CustomDropZone
                                            label="Upload CV"
                                            miniLabel="(PDF files only)"
                                            classLabel="defaultLabel"
                                            isMultiUpload={false}
                                            isImageUpload={false}
                                            maxFileSize={5242880}
                                            acceptFileTypes={"application/pdf"}
                                            viewBoxIcon={
                                                <svg width="62" height="51" viewBox="0 0 62 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M31 25.5V44.625" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M52.6739 39.0789C55.1936 37.949 57.184 36.161 58.3311 33.9972C59.4782 31.8334 59.7167 29.417 59.0088 27.1294C58.301 24.8417 56.6871 22.8131 54.422 21.3637C52.1569 19.9143 49.3695 19.1267 46.4998 19.1251H43.2448C42.4628 16.6373 41.0054 14.3276 38.9821 12.3698C36.9588 10.4119 34.4223 8.85683 31.5632 7.82144C28.7041 6.78605 25.5969 6.29729 22.4751 6.3919C19.3533 6.48651 16.2982 7.16204 13.5395 8.36769C10.7808 9.57334 8.39021 11.2777 6.54755 13.3528C4.70488 15.4278 3.45806 17.8194 2.90081 20.3479C2.34356 22.8763 2.49038 25.4758 3.33024 27.9508C4.17011 30.4259 5.68115 32.7121 7.74978 34.6376" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            uploadFileTopic={'Drag and Drop or Click to select file'}
                                            maximumFileSizeInMBLabel={'5'}
                                            setFieldValue={setFieldValue}
                                            name='candidateCV'
                                            fileInputFieldId="adminPanel_hiringPipeline_viewPipeline_addCandidate_cvInputFieldId"
                                            maxFileUploadSizeTextId="adminPanel_hiringPipeline_viewPipeline_addCandidate_maxFileUploadSizeTextCvId"
                                            errorMessage={submitCount > 0 && errors.candidateCV}
                                            validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_cvUploadvalidationMsgId"
                                            isInvalid={(submitCount > 0 && errors.candidateCV) ? true : false}
                                        />

                                        <CustomDropZone
                                            label="Upload Candidate Image"
                                            miniLabel="(.jpg, .jpeg, .png files only)"
                                            classLabel="defaultLabel"
                                            isImageUpload={true}
                                            isMultiUpload={false}
                                            maxFileSize={5242880}
                                            acceptFileTypes={"image/png, image/jpeg, image/jpg"}
                                            viewBoxIcon={
                                                <svg width="62" height="51" viewBox="0 0 62 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M31 25.5V44.625" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M52.6739 39.0789C55.1936 37.949 57.184 36.161 58.3311 33.9972C59.4782 31.8334 59.7167 29.417 59.0088 27.1294C58.301 24.8417 56.6871 22.8131 54.422 21.3637C52.1569 19.9143 49.3695 19.1267 46.4998 19.1251H43.2448C42.4628 16.6373 41.0054 14.3276 38.9821 12.3698C36.9588 10.4119 34.4223 8.85683 31.5632 7.82144C28.7041 6.78605 25.5969 6.29729 22.4751 6.3919C19.3533 6.48651 16.2982 7.16204 13.5395 8.36769C10.7808 9.57334 8.39021 11.2777 6.54755 13.3528C4.70488 15.4278 3.45806 17.8194 2.90081 20.3479C2.34356 22.8763 2.49038 25.4758 3.33024 27.9508C4.17011 30.4259 5.68115 32.7121 7.74978 34.6376" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            uploadFileTopic={'Drag and Drop or Click to select file'}
                                            maximumFileSizeInMBLabel={'5'}
                                            setFieldValue={setFieldValue}
                                            name='candidateImage'
                                            fileInputFieldId="adminPanel_hiringPipeline_viewPipeline_addCandidate_imageInputFieldId"
                                            maxFileUploadSizeTextId="adminPanel_hiringPipeline_viewPipeline_addCandidate_maxFileUploadSizeTextImageId"
                                            errorMessage={submitCount > 0 && errors.candidateImage}
                                            validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_imageUploadvalidationMsgId"
                                            isInvalid={(submitCount > 0 && errors.candidateImage) ? true : false}
                                        />
                                        {props.pipelineData.apply_form_settings.request_cover_letter ?
                                            <CustomDropZone
                                                label="Upload Cover Letter"
                                                miniLabel="(PDF files only)"
                                                classLabel="defaultLabel"
                                                isMultiUpload={false}
                                                isImageUpload={false}
                                                maxFileSize={5242880}
                                                acceptFileTypes={"application/pdf"}
                                                viewBoxIcon={
                                                    <svg width="62" height="51" viewBox="0 0 62 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M31 25.5V44.625" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M52.6739 39.0789C55.1936 37.949 57.184 36.161 58.3311 33.9972C59.4782 31.8334 59.7167 29.417 59.0088 27.1294C58.301 24.8417 56.6871 22.8131 54.422 21.3637C52.1569 19.9143 49.3695 19.1267 46.4998 19.1251H43.2448C42.4628 16.6373 41.0054 14.3276 38.9821 12.3698C36.9588 10.4119 34.4223 8.85683 31.5632 7.82144C28.7041 6.78605 25.5969 6.29729 22.4751 6.3919C19.3533 6.48651 16.2982 7.16204 13.5395 8.36769C10.7808 9.57334 8.39021 11.2777 6.54755 13.3528C4.70488 15.4278 3.45806 17.8194 2.90081 20.3479C2.34356 22.8763 2.49038 25.4758 3.33024 27.9508C4.17011 30.4259 5.68115 32.7121 7.74978 34.6376" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                                uploadFileTopic={'Drag and Drop or Click to select file'}
                                                maximumFileSizeInMBLabel={'5'}
                                                setFieldValue={setFieldValue}
                                                name='candidateCoverLetter'
                                                fileInputFieldId="adminPanel_hiringPipeline_viewPipeline_addCandidate_clInputFieldId"
                                                maxFileUploadSizeTextId="adminPanel_hiringPipeline_viewPipeline_addCandidate_maxFileUploadSizeTextClId"
                                                errorMessage={submitCount > 0 && errors.candidateCoverLetter}
                                                validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_coverLetterUploadvalidationMsgId"
                                                isInvalid={(submitCount > 0 && errors.candidateCoverLetter) ? true : false}
                                            />
                                            : null}

                                        <Row key={`inline-radio`} className="mb-3">
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label="Employee Referrals"
                                                    name="uploadType"
                                                    type="radio"
                                                    checked={values.uploadType === 10 ? true : false}
                                                    onChange={(e) => { setFieldValue('uploadType', 10); changeUploadType(10) }}
                                                    className={styles.radioBtns}
                                                    id={`adminPanel_hiringPipeline_viewPipeline_addCandidate_employeeReferralsRadioBtnId`}
                                                />
                                            </Col>
                                            <Col className="text-center">
                                                <Form.Check
                                                    inline
                                                    label="External Recruiters"
                                                    name="uploadType"
                                                    type="radio"
                                                    checked={values.uploadType === 20 ? true : false}
                                                    className={styles.radioBtns}
                                                    onChange={(e) => { setFieldValue('uploadType', 20); changeUploadType(20) }}
                                                    id={`adminPanel_hiringPipeline_viewPipeline_addCandidate_externalRecruitersRadioBtnId`}
                                                />
                                            </Col>
                                            <Col className="text-right">
                                                <Form.Check
                                                    inline
                                                    label="Other Upload"
                                                    name="uploadType"
                                                    checked={values.uploadType === 30 ? true : false}
                                                    className={styles.radioBtns}
                                                    onChange={(e) => { setFieldValue('uploadType', 30); changeUploadType(30) }}
                                                    type="radio"
                                                    id={`adminPanel_hiringPipeline_viewPipeline_addCandidate_otherUploadRadioBtnId`}
                                                />
                                            </Col>
                                        </Row>
                                        {uploadType === 10 &&
                                            <CustomTextField
                                                label="Employee Details"
                                                classLabel="defaultLabel"
                                                controlId="adminPanel_hiringPipeline_viewPipeline_addCandidate_employeeDetailsFieldId"
                                                type="text"
                                                name="employeeDetails"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                errorMessage={errors.employeeDetails}
                                                validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_employeeDetailsValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.employeeDetails}
                                            />
                                        }

                                        {uploadType === 20 &&
                                            <CustomTextField
                                                label="External Recruiter Details"
                                                classLabel="defaultLabel"
                                                controlId="adminPanel_hiringPipeline_viewPipeline_addCandidate_externalRecruiterFieldId"
                                                type="text"
                                                name="recruiterDetails"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                errorMessage={errors.recruiterDetails}
                                                validationMessageId="adminPanel_hiringPipeline_viewPipeline_addCandidate_externalRecruiterValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.recruiterDetails}
                                            />
                                        }
                                        <Row>
                                            {props.pipelineData.apply_form_settings.request_salary_expectation ? <Col>
                                                <Form.Label className={styles.defaultLabel}>
                                                    Salary Expectation &nbsp; (&nbsp;<span className={styles.currencyLabel}>{props.pipelineData.job_details.paid_currency}</span>&nbsp;-&nbsp;<span className={styles.currencyLabel}>{props.pipelineData.job_details.salary_paid_by && props.pipelineData.job_details.salary_paid_by === 10 ? "Hourly" : props.pipelineData.job_details.salary_paid_by === 20 ? "Daily" : props.pipelineData.job_details.salary_paid_by === 30 ? "Weekly" :props.pipelineData.job_details.salary_paid_by === 40 ? "Fortnight" : props.pipelineData.job_details.salary_paid_by === 50 ? "Monthly" : null}</span>&nbsp;)
                                                </Form.Label>
                                                <CustomTextField
                                                    // label={"Salary Expectation" + " ( " + {props.pipelineData.job_details.paid_currency} + " )"}
                                                    classLabel="defaultLabel"
                                                    controlId="adminPanel_hiringPipeline_viewPipeline_salaryexpectationFieldId"
                                                    type="text"
                                                    name="salaryExpectation"
                                                    placeholder={props.pipelineData.job_details.paid_currency}
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    errorMessage={errors.salaryExpectation}
                                                    validationMessageId="adminPanel_hiringPipeline_viewPipeline_salaryExpectationvalidationMsgId"
                                                    isInvalid={submitCount > 0 && !!errors.salaryExpectation}
                                                />
                                            </Col> : null}
                                            {props.pipelineData.apply_form_settings.request_available_date ? <Col>
                                                <Form.Label className={styles.defaultLabel} id="adminPanel_hiringPipeline_viewPipeline_AvailableDateTextId">
                                                    Available Date
                                                </Form.Label>
                                                <Datetime
                                                    value={values.availableDateTime}
                                                    timeFormat={false}
                                                    isValidDate={valid}
                                                    onChange={(e) => { setFieldValue('availableDateTime', e); }}
                                                    inputProps={{ readOnly: true }}
                                                    className={
                                                        ((submitCount > 0 && errors.availableDateTime === 'Required') || (submitCount > 0 && errors.availableDateTime === 'Past Dates Not Accepted')) ?
                                                            styles.errorBorder
                                                            : styles.normalBorder
                                                    }
                                                />
                                                {(submitCount > 0 && errors.availableDateTime) &&
                                                    <p className={styles.errorMsg}>{errors.availableDateTime}</p>
                                                }
                                            </Col> : null}
                                        </Row>
                                        <div className="mt-4 mb-3">
                                            <CustomButton
                                                buttonType="submit"
                                                id="adminPanel_hiringPipeline_viewPipeline_addCandidate_submitBtnId"
                                                label="Submit"
                                                type="primaryBtn"
                                                disabled={isUploadLoading ? true : false}
                                                backicon={isUploadLoading === true && <i className="fas fa-circle-notch fa-spin"></i>}
                                            />
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Container>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default AddCandidate;
